<template>
<div class="about_menu_top  textalign_left">    
    <div style="background: #fff;max-width: 1920px;margin: 0 auto;"   class="ms-controller fangyicontain">
        <div style="margin: 0 auto;">
            <div style="height: 8300px;background: url('https://p1.fishqc.net/FgvHZTkTqMBJ4DTJ2_W5YFjrrZVz') center center no-repeat;background-size: auto 100%;">
                <div class="mumcontain">
                    <div>
                        <div>
                            <div class="double11P3_desctitle">护肤优品</div>
                            <div class="double11P3_desc1">各类护肤用品是小仙女们双十一的备战重点，日常护肤水乳霜必不可少，</div>  
                            <div class="double11P3_desc1">面膜和眼部护理更需精心挑选。</div>    
                        </div>
                        <div  class="munbox" :style="{marginTop: index1==0?'40px':'50px'}" v-for="(item,index1) in productdata">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> -->

                            <div class="dec-text">{{item.destext}}
                                <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div>
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title">{{val.title}}</div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address"  :style="{lineHeight: val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'40px':'18px'}">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips" :style="{width: val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'98px':'auto',height:val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'auto':'30px',lineHeight:val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'20px':'30px',padding:val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'0 4px':'0 12px'}" v-html="val.tips"></div>
                                                </div>
                                                <!-- padding:val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'0 4px':'0 12px' -->
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 76px;box-sizing: border-box;">
                        <div>
                            <div class="double11P3_desctitle">美妆优品</div>
                            <div class="double11P3_desc1">小仙女们的双十一第二大战场大多是美妆用品，适逢秋冬换季，</div>  
                            <div class="double11P3_desc1">适合干冷天气和当季流行的美妆优品为你奉上。</div>    
                        </div>
                        <div class="munbox" :style="{marginTop: index2==0?'40px':'50px'}" v-for="(item,index2) in productdata1">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> nJTEcv-p9EwhKu3ctCE3dQ-->

                            <div class="dec-text">{{item.destext}}
                                <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div>
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand" :style="{lineHeight: val.id=='nJTEcv-p9EwhKu3ctCE3dQ'?'23px':'31px'}"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title" >{{val.title}}</div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips">{{val.tips}}</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 76px;box-sizing: border-box;">
                        <div>
                            <div class="double11P3_desctitle">母婴优品</div>
                            <div class="double11P3_desc1">除了小仙女们的美妆护肤品，母婴用品也在妈妈们的囤货计划中，安全的</div>  
                            <div class="double11P3_desc1">母婴优品才经得住妈妈们的精挑细选。</div>    
                        </div>
                        <div class="munbox" :style="{marginTop: index3==0?'40px':'50px'}"  v-for="(item,index3) in productdata2">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> -->

                            <div class="dec-text">{{item.destext}}
                                <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div>
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish" v-if="val.id !== 'Oenw-8ZJEpUMpmz5Sg5qUQ'"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title" :style="{paddingBottom: val.id=='Oenw-8ZJEpUMpmz5Sg5qUQ'?'6px':'18px'}">{{val.title}}</div>
                                                <div v-if="val.id == 'Oenw-8ZJEpUMpmz5Sg5qUQ'">
                                                    <img src="https://p1.fishqc.net/FnUDkSVsgSVkNP6okNzaUL6Jl6kt">
                                                </div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips">{{val.tips}}</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 76px;box-sizing: border-box;">
                        <div>
                            <div class="double11P3_desctitle">个护优品</div>
                            <div class="double11P3_desc1">消耗量大的日常个护用品，双十一囤货计划也是不可或缺的，适逢换季，</div>  
                            <div class="double11P3_desc1">选择绿鱼优品，安心衔接夏秋。</div>    
                        </div>
                        <div class="munbox" :style="{marginTop: index4==0?'40px':'50px'}" v-for="(item,index4) in productdata3">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> -->

                            <div class="dec-text">{{item.destext}}
                                <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div>
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title">{{val.title}}</div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips">{{val.tips}}</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="techcontain">
                    <img src="https://p1.fishqc.net/Fo0Fw_PygpyxOAPw6vbj1ljgUr_R" style="width: 100%;">
                    <div style="padding-top: 74px;text-align: center;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/Fgf5PNG1I94Zhg4xqmw7PlH6V3ay" >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain{
    font-size: 0;
}

.mumcontain{
    width: 1000px;
    margin:0 auto;
    display: block;
    text-align: center;
    padding-top: 865px;
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(61,186,173,0.9);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    
    background: #F8F8FE;
    border-radius:24px;
    padding:0 32px 29px;
    margin-top: 50px;
    box-sizing: border-box;

}

.munbox .munbox1{
    margin-top: 40px;
}
.producttype{
    display:inline-block;
    width:177px;
    height:48px;
    font-family: 'Source Han Serif CN';
    /*padding-top: 7px;*/
    box-sizing: border-box;
    line-height: 48px;
    color:#fff;
    font-size:30px;
    text-align:center;
    border-bottom-left-radius:42px;
    border-bottom-right-radius:42px;
    /*background: linear-gradient(0deg, #A9A0FF, #8360DB);*/
    background: -webkit-linear-gradient(top, #A9A0FF, #8360DB);
    background: -o-linear-gradient(top, #A9A0FF, #8360DB);
    background: -moz-linear-gradient(top, #A9A0FF, #8360DB);
    background: -ms-linear-gradient(top, #A9A0FF, #8360DB);
    background: -webkit-gradient(linear, 0% 100%, from(#A9A0FF), to(#8360DB));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#A9A0FF), color-stop(100%,#8360DB));
    /*box-shadow: 0px 0px  8px #39b0a3;*/
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:10px 32px 18px;
    box-sizing:border-box;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #6E65C5;
    line-height: 36px;
}

.dec-text{
    /*font-size:18px;
    color:#494947;*/
    /*line-height:30px;*/
    /*text-indent:3px;*/
    text-align:left;
    /*padding:20px 32px;*/
    background-color:#fff;
    border-radius:16px;

    position:relative;
    margin-bottom: 30px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #6E65C5;
    line-height: 36px;
    padding:10px 32px 18px;
    box-sizing:border-box;
    margin-top: 30px;
    
}
.tips{
    /*width: 174px;*/
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-12px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    background: linear-gradient(180deg, #A79EFE, #867EDD);
    padding:0 20px;
    box-sizing: border-box;
    
}
.tipstext{
    display:inline-block;
    font-size:22px;
    font-family: Source Han Sans CN;
    font-weight:400;
    color:#fff;
    line-height: 36px;
}

.productdetailcontain{
    width: 456px;
    margin-right: 22px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 160px;
    vertical-align: top;
    margin-bottom: 32px;
    cursor: pointer;

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(2n){
    margin-right: 0px;
}

.imgcontain{
    width: 154px;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:10px;
    bottom:8px;
}
.class1{
    width:90px;
    height:82px;
}
.class2{
    width:116px;
    height:78px;
}
.class3{
    width:78px;
    height:102px;
}
.class4{
    width:49px;
    height:109px;
}
.class5{
    width:45px;
    height:108px;
}
.class6{
    width:70px;
    height:101px;
}
.class7{
    width:80px;
    height:60px;
}
.class8{
    width:71px;
    height:92px;
}
.class9{
    width:40px;
    height:110px;
}
.class10{
    width:65px;
    height:99px;
}

.class11{
    width:51px;
    height:115px;
}
.class12{
    width:71px;
    height:117px;
}
.class13{
    width:55px;
    height:117px;
}
.class14{
    width:48px;
    height:120px;
}
.class15{
    width:53px;
    height:121px;
}
.class16{
    width:47px;
    height:121px;
}

.class17{
    width:50px;
    height:119px;
}
.class18{
    width:42px;
    height:120px;
}
.class19{
    width:46px;
    height:120px;
}
.class20{
    width:54px;
    height:122px;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:0px 0 0px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color: #6E65C5;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #6E65C5;
    line-height: 31px;
}

.title{
    font-size:18px;
    line-height: 18px;
    font-family:PingFang SC;
    font-weight:400;
    color: #6E65C5;
    padding-bottom: 18px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #6E65C5;
    line-height: 31px;
}

.detail-tips{
    padding:0 12px;
    height:30px;
    background: #FBA74D;
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:#fff;
    line-height: 30px;
    display:inline-block;
    text-align: center;
    opacity: 0.7;
   /* position: absolute;
    right: 25px;
    bottom:32px;*/
    vertical-align: bottom;

}
.address{
    /*padding-top: 16px;*/
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #6E65C5;
    line-height: 18px;
    vertical-align: bottom;
}

.techcontain{
    padding-top: 74px;
    box-sizing: border-box;
    width: 1042px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.double11P3_desctitle{
    font-size: 36px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    padding-bottom: 22px;
    box-sizing: border-box;

}

.double11P3_desc1{
    width: 856px;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 48px;
    margin:0 auto;
}

.position_center{
    position: absolute;
    top:50%;
    transform: translate(0,-50%);
    width: 100%;
}

.justify-content_flex-justify{
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
.align-items_flex-end{
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata:[
            {
                tap:'面膜',
                dec:'剁手必囤好物',
                destext:'最长情的护肤品，一定是面膜，见效快，消耗更快，选择困难症的姐妹认准安全绿鱼面膜，这个剁手节必须安排上。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FqFETFf08E0QJW_-KXZ0zrsU52Kf',
                    class:'class1',
                    brand:'VAQUA活泉 ',
                    title:'每日舒缓保湿屏障 修护面膜',
                    tips:'止痒去红<br>走红小泡弹',
                    address:'中国',
                    type:'cosmetic',
                    id:'McQ6CJX3p0Cn48EpoJHC6Q',
                    position:'left',
                    width:"width1",
                    title_width:'title_width1',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/FsO9pi3ICPOOzGwda3uMn8drt7G-',
                    class:'class2',
                    brand:'LA ROCHE POSAY 理肤泉 ',
                    title:'B5多效保湿修复面膜',
                    tips:'密集修护',
                    address:'法国',
                    type:'cosmetic',
                    id:'iN0jwvCNoi5RCQ9ymBmtqA',
                    position:'left',
                    width:"width2",
                    title_width:'title_width2'

                }]
            },
            {
                tap:'眼部护理',
                dec:'打造迷人眼眸',
                destext:'眼周的汗腺与皮脂腺的分布少，容易缺水，而每天眨动上万次的高强度运动，更容易诱发皱纹，安全的眼部护理产品必不可少。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FvLVDkmcd7tcRO6YWmQVa6QHC_mp',
                    class:'class3',
                    brand:'REVEDA悦肤达 ',
                    title:'黛铂唯肌透致 护微晶眼贴',
                    tips:'逆龄小熨斗',
                    address:'中国',
                    type:'cosmetic',
                    id:'JLKTfqDoRSYD5YXDXbmZyA',
                    position:'right',
                    width:"width3",
                    title_width:'title_width3'
                },{
                    img:'https://p1.fishqc.net/FhxnW3PPrb2lzNKBeHVIRHJjGq45',
                    class:'class4',
                    brand:'SHISEIDO资生堂',
                    title:'悦薇珀翡塑颜抗皱霜',
                    tips:'拯救小细纹',
                    address:'日本',
                    type:'cosmetic',
                    id:'GpWNhrQ5fiCeARdrf9pgcQ',
                    position:'right',
                    width:"width4",
                    title_width:'title_width4'

                }]
            },
            {
                tap:'爽肤水',
                dec:'助力护肤吸收',
                destext:'爽肤水作为洁面后护肤前承上启下的一步，可以加速后续护肤品的吸收和渗透，选择绿鱼爽肤水皮肤安全又水嫩。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FpJ9uNRvterUIdSx-MxEKI7_HSsP',
                    class:'class5',
                    brand:'My Clorisland  花皙蔻 ',
                    title:'洛神花细致毛孔精华水',
                    tips:'混油皮必备',
                    address:'中国',
                    type:'cosmetic',
                    id:'BgdaLLepToHrcHu00hNxTg',
                    position:'left',
                    width:"width5",
                    title_width:'title_width5'
                },{
                    img:'https://p1.fishqc.net/FtrydJmOffKBW76bM4iD8pzU1jiN',
                    class:'class6',
                    brand:'DECORTE黛珂 ',
                    title:'紫苏精华水',
                    tips:'改善粗糙',
                    address:'日本',
                    type:'cosmetic',
                    id:'I77aXPtxoCRMp5U1HM69ZQ',
                    position:'left',
                    width:"width6",
                    title_width:'title_width6'
                }]
            },
            {
                tap:'面霜',
                dec:'滋润干燥肌肤',
                destext:'面霜相较乳液滋润性更强，秋冬干燥寒冷，皮肤自身分泌的油脂减少，安全面霜可以锁住水份，在皮肤表层形成保护作用。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FuxMbRd229Sicj68hV-wK-xESFK2',
                    class:'class7',
                    brand:'CUREL珂润 ',
                    title:'润浸保湿滋养乳霜',
                    tips:'深层补水',
                    address:'日本',
                    type:'cosmetic',
                    id:'F0jP8U9azuisaJBtivYieA',
                    position:'right',
                    width:"width7",
                    title_width:'title_width7'
                },{
                    img:'https://p1.fishqc.net/Fh7GyCV5CSbF2sOdSgT9ZJfANanN',
                    class:'class8',
                    brand:'OLAY玉兰油 ',
                    title:'菁醇青春绵绒霜 (空气感)',
                    tips:'清新不油腻',
                    address:'美国',
                    type:'cosmetic',
                    id:'pVkG7F4Yd-2Xg7sgf4DJEA',
                    position:'right',
                    width:"width8",
                    title_width:'title_width8'
                }]
            }

        ],
        productdata1:[
            {
                tap:'粉底液',
                dec:'营造天生好皮肤',
                destext:'劣质粉底液使用感差伤害皮肤，严重的可能使人体重金属中毒，打造完美妆容第一步，选择安全的粉底液极其重要。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FkHirDXzMki02bevcXncpmc0uZex',
                    class:'class9',
                    brand:'CLE DE PEAU  BEAUTE肌肤之钥 ',
                    title:'光缎粉底霜',
                    tips:'水润透亮',
                    address:'日本',
                    type:'cosmetic',
                    id:'O1qfsawhU3JcIwxxyoUL7Q',
                    position:'left',
                    width:"width9",
                    title_width:'title_width9',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/Fqr9_mwM8nTcVClN8J93wr-Is1he',
                    class:'class10',
                    brand:'SHISEIDO资生堂 ',
                    title:'随肌应变光透粉底液  (G2)',
                    tips:'奶油肌必备',
                    address:'日本',
                    type:'cosmetic',
                    id:'mengizLrxYWIVg18lngOWA',
                    position:'left',
                    width:"width10",
                    title_width:'title_width10'

                }]
            },
            {
                tap:'口红',
                dec:'一秒提亮气色',
                destext:'秋冬限定色号怎么选？劣质口红鲜艳亮丽，但成分复杂，容易诱发过敏甚至炎症。想要安全又好看，跟着榜单选。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FvSy-NHgEgLox_ZEsujSnZ-6-3e8',
                    class:'class11',
                    brand:'GIORGIO ARMANI阿玛尼 <br>「传奇红管」 臻致丝绒哑光唇釉',
                    brand1:'阿玛尼「传奇红管」 臻致丝绒哑光唇釉',
                    title:'  (208 日出奶橘咖)',
                    tips:'秋冬限定',
                    address:'意大利',
                    type:'cosmetic',
                    id:'nJTEcv-p9EwhKu3ctCE3dQ',
                    position:'right',
                    width:"width11",
                    title_width:'title_width11'
                },{
                    img:'https://p1.fishqc.net/FqhVzXBEHNVI9UEb_EEH-irOosxT',
                    class:'class12',
                    brand:'CHANEL香奈儿 ',
                    title:'魅力炫光唇釉  (80 Timeless)',
                    tips:'高级显色',
                    address:'法国',
                    type:'cosmetic',
                    id:'7q40WmzzMLTQxHo2FMMsKQ',
                    position:'right',
                    width:"width12",
                    title_width:'title_width12'

                }]
            }
            

        ],
        productdata2:[
            {
                tap:'儿童面霜',
                dec:'呵护宝宝嫩滑脸蛋',
                destext:'宝宝皮肤屏障发育不完善，抵御干燥的能力弱，在干燥秋冬更容易出现干裂、红痒等情况，选择温和的面霜更适合宝宝。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FtvWsMgltboo50orXjdD1tCEme7d',
                    class:'class13',
                    brand:'AIREE安伊妮 ',
                    title:'儿童面霜',
                    tips:'保湿舒缓',
                    address:'日本',
                    type:'cosmetic',
                    id:'Oenw-8ZJEpUMpmz5Sg5qUQ',
                    position:'left',
                    width:"width13",
                    title_width:'title_width13',
                    effency:'舒缓、保湿、温和无刺激功效显著',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/FiVGQsdNYcCzn-4_8uDHDt9rjn9Y',
                    class:'class14',
                    brand:'WELEDA维蕾德 ',
                    title:'金盏花婴幼儿面霜',
                    tips:'舒缓干燥',
                    address:'瑞士',
                    type:'cosmetic',
                    id:'10qvUqjzMKGP13oLrXKD7g',
                    position:'left',
                    width:"width14",
                    title_width:'title_width14'


                }]
            },
            {
                tap:'儿童洗浴 ',
                dec:'保护宝宝肌肤健康',
                destext:'洗发沐浴二合一同时避免两种产品的交叉使用和更换洗液的繁琐过程，看准安全好物，更能保护宝宝肌肤健康。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FsptWnnyvBT9bDeNp632WpcRUx0l',
                    class:'class15',
                    brand:'MINOIS PARIS 巴黎宝宝 ',
                    title:'婴幼儿童洗发沐浴露 二合一',
                    tips:'温润洁净',
                    address:'法国',
                    type:'cosmetic',
                    id:'Oin68W6VJ2rQhJ6uHjrUeg',
                    position:'right',
                    width:"width15",
                    title_width:'title_width15'
                },{
                    img:'https://p1.fishqc.net/FgIJdKB5HjwEGpMzg2BDY5P-45PF',
                    class:'class16',
                    brand:'EVEREDEN ',
                    title:'婴儿洗发沐浴二合一',
                    tips:'滋润保湿',
                    address:'美国',
                    type:'cosmetic',
                    id:'uhEudEgwscbvLqIBlJ6jSA',
                    position:'right',
                    width:"width16",
                    title_width:'title_width16'

                }]
            }
            

        ],
        productdata3:[
            {
                tap:'洗发水',
                dec:'拯救秋冬毛躁',
                destext:'洗发水的挑选不仅需要根据发质，还应该配合季节的变换，秋冬易干枯毛躁，“头等大事”，选择安全的洗发水尤为重要。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FrD2IR-alWEMj4sdtcYGpV0iA51Q',
                    class:'class17',
                    brand:'AQUAIR水之密语 ',
                    title:'凈澄水活洗发露',
                    tips:'柔顺滋润',
                    address:'日本',
                    type:'cosmetic',
                    id:'QZAwyPOKdqsoQnqfALi9jg',
                    position:'left',
                    width:"width17",
                    title_width:'title_width17',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/FmYhMBmmXTbBvVvzSsT0gimFV3_m',
                    class:'class18',
                    brand:'SYOSS丝蕴 ',
                    title:'无硅油水润洗发水',
                    tips:'温和水润',
                    address:'日本',
                    type:'cosmetic',
                    id:'IV2nPonCK5qEiNhjgGRH8Q',
                    position:'left',
                    width:"width18",
                    title_width:'title_width18'

                }]
            },
            {
                tap:'身体乳',
                dec:'身体肌肤保护膜',
                destext:'身体乳为皮肤补充所需的水分和养分，滋润肌肤。防止皮肤干燥缺水，在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/Fm1lxeCh4btmLQws10u8zzOEYS7u',
                    class:'class19',
                    brand:"KIEHL'S科颜氏 ",
                    title:'全身保湿护肤乳液',
                    tips:'全身保湿',
                    address:'美国',
                    type:'cosmetic',
                    id:'6eh2v7orZILg00rqBUpmwg',
                    position:'right',
                    width:"width19",
                    title_width:'title_width19'
                },{
                    img:'https://p1.fishqc.net/Fv1XSsVRvXQ41ajCKDAwje_1Ql7U',
                    class:'class20',
                    brand:'CeraVe ',
                    title:'长效保湿修复乳',
                    tips:'24H保湿',
                    address:'法国',
                    type:'cosmetic',
                    id:'G8DSWGQVu9-PBfLpFkvDiA',
                    position:'right',
                    width:"width20",
                    title_width:'title_width20'

                }]
            }
            

        ],
        imgarr:['https://product.fishqc.com/img/activity/618/tech.png','https://product.fishqc.com/img/activity/618/tech-white.png','https://product.fishqc.com/img/activity/618/tech-kangyang.png'],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>